"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositions = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const error_1 = __importDefault(require("../util/error"));
const fetch_1 = __importDefault(require("../util/fetch"));
const positionsQuery = (0, graphql_tag_1.default) `
  query PositionsQuery($id: ID!) {
    workspace(id: $id) {
      positions(archived: true) {
        id
        name
        shortName
        productionResourceType {
          name
          defaultHourlyProductivity
        }
        color
        archived
        purpose
        productionResourceType {
          name
          defaultHourlyProductivity
        }
      }
    }
  }
`;
const getPositions = async (args) => {
    const { data, errors } = await (0, apollo_1.query)(positionsQuery, {
        variables: args,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace.positions;
};
exports.getPositions = getPositions;
async function requestPositions(variables) {
    const response = await (0, fetch_1.default)({ query: positionsQuery, variables });
    if (!response)
        return error_1.default.noResponse();
    // @ts-expect-error
    const { errors, data } = response;
    if (errors) {
        return error_1.default.apiError('positions', errors);
    }
    return data.workspace.positions;
}
exports.default = requestPositions;
